
















































































































































































































































import {
  Component, Vue, Provide, Prop,
} from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, DatePicker, Select, Option, Cascader, RadioGroup, Radio, Message,
} from 'element-ui';
import Devisive from '@/servers/modules/decisive'; // server
import Study from '@/servers/modules/decisive/study'; // server
import MyDialog from '@/components/dialog/Index.vue'; // dialog
import { Mutation, Getter } from 'vuex-class';
import { classNode } from '../studyReport.vue';

enum Status {
    RIGHT = '14',
    WRONG = '12',
    NOANSWER = '11',
    ALL = '-1'
}

interface classNodeLess {
  nodeId: number,
  nodeType: string,
  orderNum: string,
  processInstanceId?: any
}

interface IssueNum {
  value: number,
  label: string
}


Vue.use(Loading.directive);
@Component({
  components: {
    Table,
    TableColumn,
    Scrollbar,
    Button,
    DatePicker,
    Select,
    Option,
    Cascader,
    MyDialog,
    RadioGroup,
    Radio,
    Message,
  },
})
export default class extends Vue {
  @Getter public skeleton: any;

  @Mutation public setSkeletonDescribe: any;

  @Mutation public openDialog:any;

  @Mutation public closeDialog: any;

  // ========================================数据
  // ----------------------------------------数据
  // 课程名称
  public articleName: string = window.LS.get('basicData').courseName;

  // 章节(课程节点)
  public chapter!: classNodeLess;

  // 统计
  public calen:any = {};

  // arr - 重新练习
  public practiceArr:any = [];

  // 评测
  public evaluate:any=[];

  // 前测
  public phasetest:any=[];

  // 后测
  public unittest:any=[];

  // ---扩展练习
  public extendFinish: boolean = false;

  public extendReview: boolean = false;

  // 接口参数
  public nodeGroupId!: number;

  extraBtn: string = '开始拓展练习';

  numSelectArr!: IssueNum[];

  /* 试卷答题数目 */
  reviewTypeArr = [
    {
      value: '12',
      label: '错题',
    },
    {
      value: '14',
      label: '对题',
    },
    {
      value: '11',
      label: '未答题',
    },
    {
      value: '-1',
      label: '全部题',
    },
  ]

  public extendData = {
    all: 0,
    articleName: '',
    itemNum: 0,
    time: '',
    numSelect: 50,
    reviewType: '-1',
    review: {
      all: 0,
      right: 0,
      wrong: 0,
      no: 0,
      doubt: 0,
    },
  }


  // 暂存数据
  private temporaryStorageForm:any = '';

  // 重练时需要的节点信息
  private nodes:any ={}

  // ----------------------------------------样式
  public tableHeaderClassName() {
    return 'table-header';
  }

  public tableRowClassName() {
    return 'table-row';
  }

  // 合并行或者列
  public objectSpanMethod(
    {
      row, column, rowIndex, columnIndex,
    }: { row: object, column: { property: any }, rowIndex: number, columnIndex: number },
  ) {
    // 确保为第一列
    if (columnIndex == 0) {
      // 确保为第一行
      if (rowIndex === 0) {
        if (this[column.property]) {
          return {
            rowspan: this[column.property].length,
            colspan: 1,
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 0,
        };
      }
    }
  }

  private cellClassName({
    row, column, rowIndex, columnIndex,
  }:any) {
    if (columnIndex === 0) {
      return 'cell-style';
    }
    return '';
  }

  // ----------------------------------------控制
  /**
   * @description 控制显示页面内容
   * @param statistics 训练统计分析(正确率，掌握度，星级题)
   * @param practice 重新练习表格
   * @param evaluate 评测统计分析(学前测评，学后测评)
   *        @param phasetestTableColumn 评测统计分析 - 学前测评
   *        @param unittestTableColumn 评测统计分析 - 学后测评
   * @param phasetest 前测统计分析
   * @param unittest 后测统计分析
   * @param extra 扩展练习
   */
  public status = {
    statistics: 1,
    practice: 1,
    evaluate: 1,
    phasetest: 1,
    unittest: 1,
    extra: 0,
    phasetestTableColumn: 1,
    unittestTableColumn: 1,
  };

  // ========================================初始化

  // 由父组件调用
  /**
   * @description 区分学习阶段
   * @param GROUP 整个课程 | 阶段
   * @param EVALUATE 学前测评 | 学后测评
   * @param PHASETEST 阶段 - 前测
   * @param PRACTICE 阶段 - 训练单元
   * @param UNITTEST 阶段 - 后测
   * @param EXTRA 扩展练习
   *
   * ------------------------------
   *
   * @param node.orderNum
   * @description 区分当前课程节点包含的内容
   * 分割后数组长度为1：整本课程
   * 分割后数组长度为2：整本课程
   * 分割后数组长度为3：学前测评 | 阶段训练 | 学后测评
   * 分割后数组长度为4： 阶段 - (前测 | 训练单元 | 后测)
   */
  public isShowNode(node: any) {
    this.setSkeletonDescribe(true);
    console.log('detail-node', node);
    // 重练需要获取节点信息
    this.nodes = node;
    // 初始化显示状态
    this.status = {
      statistics: 1,
      practice: 1,
      evaluate: 1,
      phasetest: 1,
      unittest: 1,
      extra: 0,
      phasetestTableColumn: 1,
      unittestTableColumn: 1,
    };

    if (node.orderNum) {
      const treeDeepArr = node.orderNum.split(',');
      this.chapter = {
        nodeId: node.nodeId,
        nodeType: node.nodeType,
        orderNum: node.orderNum,
      };
      console.log(treeDeepArr.length);
      this.nodeGroupId = node.nodeGroupId;
      switch (treeDeepArr.length) {
        case 1:
          this.status.practice = 0;
          break;
        case 2:
          this.status.practice = 0;
          break;
        case 3:
          console.log(node);
          if (node.nodeName.indexOf('学前评测') > -1) {
            this.status = {
              statistics: 0,
              practice: 0,
              evaluate: 1,
              phasetest: 0,
              unittest: 0,
              extra: 0,
              phasetestTableColumn: 1,
              unittestTableColumn: 0,
            };
          } else if (node.nodeName.indexOf('学后评测') > -1) {
            this.status = {
              statistics: 0,
              practice: 0,
              evaluate: 1,
              phasetest: 0,
              unittest: 0,
              extra: 0,
              phasetestTableColumn: 0,
              unittestTableColumn: 1,
            };
          } else if (node.children.length > 1 && node.children.length < 4) { // 展示前测和重练表格
            console.log(node.children.length);
            this.status.evaluate = 0;
            this.status.practice = 1;
            this.status.unittest = 0;
          } else if (node.children.length >= 4) { // 展示前测、后测和重练表格
            console.log(node.children.length);
            this.status.evaluate = 0;
            this.status.practice = 1;
            this.status.unittest = 1;
          } else if (node.children.length <= 1) { // 只展示前测
            console.log(node.children.length);
            this.status.evaluate = 0;
            this.status.practice = 0;
            this.status.unittest = 0;
          } else {
            this.status.evaluate = 0;
            this.status.practice = 0;
          }
          break;
        case 4:
          if (node.nodeName.indexOf('前测') > -1) {
            this.status = {
              statistics: 1,
              practice: 0,
              evaluate: 0,
              phasetest: 1,
              unittest: 0,
              extra: 0,
              phasetestTableColumn: 0,
              unittestTableColumn: 0,
            };
          } else if (node.nodeName.indexOf('后测') > -1) {
            this.status = {
              statistics: 1,
              practice: 0,
              evaluate: 0,
              phasetest: 0,
              unittest: 1,
              extra: 0,
              phasetestTableColumn: 0,
              unittestTableColumn: 0,
            };
          } else
          if (node.nodeType == 'EXTRA') {
            this.status = {
              statistics: 0,
              practice: 0,
              evaluate: 0,
              phasetest: 0,
              unittest: 0,
              extra: 1,
              phasetestTableColumn: 0,
              unittestTableColumn: 0,
            };
          } else {
            this.status = {
              statistics: 1,
              practice: 1,
              evaluate: 0,
              phasetest: 0,
              unittest: 0,
              extra: 0,
              phasetestTableColumn: 0,
              unittestTableColumn: 0,
            };
          }
          break;
      }
      console.log('this.status', this.status);
      this.init();
    }
    // 强制更新内容
    this.$forceUpdate();
  }

  public init() {
    if (this.chapter.nodeType == 'EXTRA') {
      this.getExtendData();
    } else {
      const params: classNodeLess = {
        processInstanceId: window.LS.get('jse_data').processInstanceId,
        ...this.chapter,
      };

      this.getPracticeData(params);
      this.getEvaluateCalculationDate(params);
      if (this.status.phasetest) {
        this.getTestStatisticAnalysisBefore(params);
      }
      if (this.status.unittest) {
        this.getTestStatisticAnalysisLast(params);
      }
      this.setSkeletonDescribe(false);
    }
  }

  // 扩展练习
  public async getExtendData() {
    const paper = Loading.service({ text: '加载中' });
    const params = {
      processDefinitionId: window.LS.get('jse_data').processDefinitionId,
      processInstanceId: window.LS.get('jse_data').processInstanceId,
      nodeId: this.nodeGroupId,
      itemNum: this.extendData.numSelect,
      nodeType: 'EXTRA',
    };
    const res = await Study.startLearning(params);
    if (!res.data.code) {
      const { data } = res.data;
      window.LS.set('jse_startstudy', data);
      this.extendData.all = data.allNum; /* 所有题 */
      this.handleOption(data.allNum); /* 答卷数目 */
      this.extendData.articleName = data.currentName;
      this.extendData.itemNum = data.itemNum;
      this.extendData.time = this.secondToDate(data.answeringTime);
      // 学完全部扩展练习
      if (data.allNum > 0) {
        this.extendFinish = false;
        if (data.htsNum > 0) {
          this.extraBtn = '继续拓展练习';
        } else {
          this.extraBtn = '开始拓展练习';
        }
      }
      // 未学完
      else {
        this.extendFinish = true;
      }
      // 统计学习数据
      if (data.cts) {
        this.extendData.review.all = data.cts.sumCorrectItems + data.cts.sumIncorrectItems;
        this.extendData.review.right = data.cts.sumCorrectItems;
        this.extendData.review.wrong = data.cts.sumIncorrectItems;
        this.extendData.review.no = data.cts.sumUnfinishedItems;
        this.extendData.review.doubt = data.cts.unsureMarkItems;
        this.extendReview = true;
      }
    }
    paper.close();
    this.setSkeletonDescribe(false);
  }

  // 扩展练习 - 处理选项
  /**
   * @description 50为默认选项，永远存在；10，20，100为可选选项
   * @example 9 - =50(9)
   * @example 19 - ~10 | =50(19)
   * @example 29 | 79 - ~10 | ~20 | =50(29|79)
   * @example 100 - ~10 | ~20 | ~50 | ~100
   */
  handleOption(num: number) {
    if (num >= 100) {
      this.numSelectArr = [
        {
          value: 100,
          label: `~100(总题量${num})`,
        },
        {
          value: 10,
          label: '~10',
        },
        {
          value: 20,
          label: '~20',
        },
        {
          value: 50,
          label: '~50',
        },
      ];
    } else if (num >= 20) {
      this.numSelectArr = [
        {
          value: 10,
          label: '~10',
        },
        {
          value: 20,
          label: '~20',
        },
        {
          value: 50,
          label: `=50(${num})`,
        },
      ];
    } else if (num >= 10) {
      this.numSelectArr = [
        {
          value: 10,
          label: '~10',
        },
        {
          value: 50,
          label: `=50(${num})`,
        },
      ];
    } else {
      this.numSelectArr = [
        {
          value: 50,
          label: `=50(${num})`,
        },
      ];
    }
  }

  // 扩展练习 - 转换为时分秒
  secondToDate(second: number): string {
    const res = second;
    const h = Math.floor(res / 3600);
    const m = Math.floor((res / 60 % 60));
    const s = Math.floor((res % 60));
    if (h > 0) {
      return `${h}小时${m}分钟${s}秒`;
    }
    if (m > 0) {
      return `${m}分钟${s}秒`;
    }
    if (s > 0) {
      return `${s}秒`;
    }
    return '0';
  }

  // 重新练习
  public async getPracticeData(params: classNodeLess) {
    const res = await Devisive.getStudyStatisticAnalysis(params);
    // 页面加载完毕执行 tabel 数据初始化
    if (!res.data.code) {
      this.calen = res.data.data;
      const table:any = [
        {
          paperAssemItemType: '-1', number: '1', docName: '总题数', docName1: '6', name: 'sumItems',
        },
        {
          paperAssemItemType: '14', number: '2', docName: '对题数', docName1: '6', name: 'sumCorrectItems',
        },
        {
          paperAssemItemType: '12', number: '3', docName: '错题数', docName1: '6', name: 'sumIncorrectItems',
        },
        {
          paperAssemItemType: '11', number: '4', docName: '未答数', docName1: '6', name: 'sumUnfinishedItems',
        },
        {
          paperAssemItemType: '15', number: '5', docName: '标记数', docName1: '6', name: 'unsureMarkItems',
        },
        {
          paperAssemItemType: '5', number: '6', docName: '5星难度数', docName1: '6', name: 'sumFiveStarItems',
        },
        {
          paperAssemItemType: '4', number: '7', docName: '4星难度数', docName1: '6', name: 'sumFourStarItems',
        },
        {
          paperAssemItemType: '3', number: '8', docName: '3星难度数', docName1: '6', name: 'sumThreeStarItems',
        },
        {
          paperAssemItemType: '2', number: '9', docName: '2星难度数', docName1: '6', name: 'sumTwoStarItems',
        },
        {
          paperAssemItemType: '1', number: '10', docName: '1星难度数', docName1: '6', name: 'sumOneStarItems',
        },
        {
          paperAssemItemType: '0.5', number: '11', docName: '半星难度数', docName1: '6', name: 'sumHalfStarItems',
        },
        // {
        //   paperAssemItemType: '0', number: '12', docName: '掌握数', docName1: '6', name: 'sumZeroStarItems',
        // },
      ];
      const data1:any = res.data.data;
      for (const j in data1) {
        for (let i = 0; i < table.length; i++) {
          if (j == table[i].name) {
            for (const k in data1[j]) {
              table[i][k] = data1[j][k];
              if (k == 'scale') { table[i][k] += '%'; }
            }
          }
        }
      }
      this.practiceArr = table;
    }
  }

  // 评测
  public async getEvaluateCalculationDate(params: classNodeLess) {
    const res = await Devisive.getEvaluateCalculationDate(params);
    if (!res.data.code) {
      this.evaluate = res.data.data;
    }
  }

  // 前测
  public async getTestStatisticAnalysisBefore(params: classNodeLess) {
    const form = { ...params };
    form.nodeType = 'PHASETEST';
    console.log(form, this.nodes.nodeInstanceId);
    const res = await Devisive.getTestStatisticAnalysis(form);
    console.log(res.data);
    if (!res.data.code) {
      const { data } = res.data;
      let phase;
      data.forEach((element:any) => {
        const time = new Date(element.testTime);
        element.lastTestTime = `${time.getFullYear()}-${Number(time.getMonth()) + 1}-${time.getDate()}`;
        if (element.nodeInstanceId == this.nodes.nodeInstanceId) {
          phase = element;
        } else if (this.nodes.nodeType == 'GROUP' && this.nodes.children[0].nodeInstanceId == element.nodeInstanceId) {
          phase = element;
        }
      });
      if (phase) {
        this.phasetest = [phase];
      } else {
        this.phasetest = data;
      }
    }
  }

  // 后测
  public async getTestStatisticAnalysisLast(params: classNodeLess) {
    const form = { ...params };
    form.nodeType = 'UNITTEST';
    const res = await Devisive.getTestStatisticAnalysis(form);
    console.log(res);
    if (!res.data.code) {
      const { data } = res.data;
      let unit:any;
      for (let i = 0; i < data.length; i++) {
        const time = new Date(data[i].testTime);
        if (data[i].testTime) {
          data[i].lastTestTime = `${time.getFullYear()}-${Number(time.getMonth()) + 1}-${time.getDate()}`;
        } else {
          data[i].lastTestTime = null;
        }
        if (this.nodes.nodeType == 'UNITTEST') {
          console.log(i, data[i].nodeInstanceId, this.nodes.nodeInstanceId);
          if (data[i].nodeInstanceId == this.nodes.nodeInstanceId) {
            this.unittest = [data[i]];
            break;
          } else {
            this.unittest = [];
          }
        } else if (this.nodes.nodeType == 'GROUP') {
          if (this.nodes.children[3] && this.nodes.children[3].nodeInstanceId == data[i].nodeInstanceId) {
            this.unittest = [data[i]];
            break;
          } else if (this.nodes.nodeName == this.articleName) {
            this.unittest = data;
          } else {
            this.unittest = [];
          }
        }
      }
    }
  }

  // ========================================操作
  // 扩展练习
  handleToggleExtra(data:any) {
    console.log('data', data);
    this.init();
  }

  // 扩展练习 - 学习
  async handleExtendStudy() {
    const resData = await Study.queryTemporaryStorage({});
    // 判断是否有暂存的内容
    if (resData.data.data) {
      const temporaryStorageForm = this.temporaryStorageForm = eval(`(${resData.data.data})`);
      console.log(temporaryStorageForm);
      // 学习类型不是exit就要提示打开模态框
      if (temporaryStorageForm.learnType != 'exit') {
        this.dialogOpen();
      } else {
        console.log('node', this.nodes);
        // 有暂存任务且节点相同
        if (temporaryStorageForm.nodeId == this.nodes.nodeGroupId) {
          this.$router.push({ name: 'sprintLearning', query: { nodeId: this.temporaryStorageForm.nodeId, isExit: true, isAgain: true } });
          this.closeDialog();
        } else {
          // 学习类型同为exit,但是节点不同提示暂存任务
          this.dialogOpen();
        }
      }
    } else {
      this.$router.push(`/decisive/sprintLearning?nodeId=${this.nodeGroupId}&itemNum=${this.extendData.numSelect}&isExit=true&isAgain=true`);
    }
  }

  // 扩展练习 - 复习
  async handleExtendReview() {
    if (this.extendData.reviewType == Status.WRONG) {
      if (this.extendData.review.wrong <= 0) {
        Message({ message: '错题数为0，不可重做', type: 'error' });
        return false;
      }
    } else if (this.extendData.reviewType == Status.RIGHT) {
      if (this.extendData.review.right <= 0) {
        Message({ message: '对题数为0，不可重做', type: 'error' });
        return false;
      }
    } else if (this.extendData.reviewType == Status.NOANSWER) {
      if (this.extendData.review.no <= 0) {
        Message({ message: '未答题数为0，不可重做', type: 'error' });
        return false;
      }
    }
    const resData = await Study.queryTemporaryStorage({});
    // 判断是否有暂存的内容
    if (resData.data.data) {
      const temporaryStorageForm = this.temporaryStorageForm = eval(`(${resData.data.data})`);
      console.log(temporaryStorageForm);
      // 从首页暂存进来的
      if (temporaryStorageForm.learnType != 'exitReview') {
        this.dialogOpen();
      } else {
        console.log('node', this.nodes);
        if (temporaryStorageForm.nodeId == this.nodes.nodeGroupId && temporaryStorageForm.paperAssemItemType == this.extendData.reviewType) {
          this.$router.push({
            name: 'sprintLearning',
            query: {
              nodeId: this.temporaryStorageForm.nodeId, paperAssemItemType: this.temporaryStorageForm.paperAssemItemType, isExit: true, isAgain: true,
            },
          });
          this.closeDialog();
        } else {
          this.dialogOpen();
        }
      }
    } else {
      this.$router.push(`/decisive/startLearningTest?nodeId=${this.nodeGroupId}&paperAssemItemType=${this.extendData.reviewType}&isExit=true&isAgain=true`);
    }
  }

  // 跳转 - 重新练习
  // 进入重练
  private async showDetail(row?: any) {
    console.log('重新练习', row, this.nodes);
    const resData = await Study.queryTemporaryStorage({});
    // 判断是否有暂存的内容
    if (resData.data.data) {
      const temporaryStorageForm = this.temporaryStorageForm = eval(`(${resData.data.data})`);
      console.log(temporaryStorageForm);
      // 不是弱项强化学习暂存--需要弹窗
      if (temporaryStorageForm.learnType != 'strong') {
        this.dialogOpen();
      } else {
        // 有暂存的内容，进行判断nodeId,相等正常进入，不相等则弹出弹框
        if (temporaryStorageForm.nodeId == this.nodes.nodeId && temporaryStorageForm.paperAssemItemType == row.paperAssemItemType) {
          this.$router.push(`/decisive/sprintLearning?nodeId=${this.nodes.nodeId}&paperAssemItemType=${row.paperAssemItemType}&isAgain=true`);
        } else {
          // nodeId 不相等打开弹窗
          this.dialogOpen();
        }
      }
    } else {
      // 跳过的节点重新进入学习
      // if (row.total == 0) {
      //   this.$router.push(`/decisive/sprintLearning?nodeId=${this.nodes.nodeId}`);
      //   return false
      // }
      // 没有暂存内容直接进入重练内容
      this.$router.push(`/decisive/sprintLearning?nodeId=${this.nodes.nodeId}&paperAssemItemType=${row.paperAssemItemType}&isAgain=true`);
    }
  }

  // 打开模态框
  private dialogOpen() {
    this.openDialog({
      visible: true,
      titleClose: true,
      titleIcon: false,
      footer: [
        {
          class: 'button-style-border',
          word: '取消',
        },
        {
          class: 'button-style-background',
          word: '进入暂存学习任务',
        },
      ],
    });
  }

  // 点击按钮进行确认和取消操作
  private dialogHandle(index: any) {
    if (index == 0) {
      this.closeDialog('this.temporaryStorageForm', this.temporaryStorageForm);
    } else {
      console.log('this.temporaryStorageForm', this.temporaryStorageForm);
      if (this.temporaryStorageForm.learnType == 'strong') {
        this.$router.push({ name: 'sprintLearning', query: { nodeId: this.temporaryStorageForm.nodeId, paperAssemItemType: this.temporaryStorageForm.paperAssemItemType, isAgain: true } });
        this.closeDialog();
      } else if (this.temporaryStorageForm.learnType == 'exit') {
        this.$router.push({ name: 'sprintLearning', query: { nodeId: this.temporaryStorageForm.nodeId, isExit: true, isAgain: true } });
        this.closeDialog();
      } else if (this.temporaryStorageForm.learnType == 'exitReview') {
        this.$router.push({
          name: 'sprintLearning',
          query: {
            nodeId: this.temporaryStorageForm.nodeId, isExit: true, paperAssemItemType: this.temporaryStorageForm.paperAssemItemType, isAgain: true,
          },
        });
        this.closeDialog();
      } else {
        this.$router.push({
          name: 'sprintLearning',
          query: {
            nodeId: this.temporaryStorageForm.nodeId, isRetraining: false, isAgain: true, isExit: true,
          },
        });
        this.closeDialog();
      }
    }
  }
}
